import { render, staticRenderFns } from "./SystemThirdParty.vue?vue&type=template&id=68282bfa&scoped=true&"
import script from "./SystemThirdParty.vue?vue&type=script&lang=js&"
export * from "./SystemThirdParty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68282bfa",
  null
  
)

export default component.exports